import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setCurrNeighborPoints } from '../../imageViewer/imageSlice';
import {
  RanchPageViewEnum,
  selectRanchPageView,
} from '../../ranches/ranchesSlice';
import {
  ResetItemsEnum,
  resetSelectFields,
  selectCurrScanID,
} from '../../select/selectSlice';

// This hook resets the point when a scan changes to avoid showing stale data
export function useResetPoints() {
  const dispatch = useAppDispatch();
  const currScanID = useAppSelector(selectCurrScanID);
  const ranchPageView = useAppSelector(selectRanchPageView);

  // Clear neighbor points when on ranch summary view to avoid stale data showing up in image viewer
  useEffect(() => {
    if (ranchPageView === RanchPageViewEnum.ranchSummary) {
      dispatch(resetSelectFields([ResetItemsEnum.PointId]));
      dispatch(setCurrNeighborPoints([]));
    }
  }, [ranchPageView]);

  // Clear points when a scan changes
  useEffect(() => {
    // dispatch(resetSelectFields([ResetItemsEnum.PointId])); // this interferes with loading the point from the url params
    dispatch(setCurrNeighborPoints([]));
  }, [currScanID]);
}
